module.exports = __webpack_public_path__ + "static/media/honor_diamond.f815b8c8.png";